import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/REPORT_LOCATIONS';

export const {
    action: fetchLocations,
    success: fetchLocationsSuccess,
    failed: fetchLocationsFailed,
} = createAction(
    `${domain}/FETCH_LOCATIONS`,
    institutionId => ({institutionId}),
    (institutionId, locations) => ({institutionId, locations}),
);
